module.exports = require("util");


//////////////////
// WEBPACK FOOTER
// external "util"
// module id = 3
// module chunks = 0